"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDataRow = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../../assets/styles/config");
exports.StyledDataRow = styled_components_1.default.div `
  border-bottom: 1px solid ${config_1.colors.pavement};
  display: flex;
  flex-direction: row;
  height: 80px;
  justify-content: space-between;
  padding: 18px 0;

  &:last-child {
    border: none;
  }
`;
